<template>
    <v-row id="settings" class="settings-page pt-2 no-gutters">
        <v-col cols="12"><MyBoat></MyBoat></v-col>
        <v-col cols="12"><SystemStatus></SystemStatus></v-col>
        <v-col cols="12"><Control></Control></v-col>
        <v-col cols="12"><Sensors></Sensors></v-col>
    </v-row>
</template>
<script lang="ts">
    //import { alarm, sensor } from "@/store";
    import { defineComponent, onMounted } from "vue";

    export default defineComponent({
        name: "Settings",
        components: {
            MyBoat: () =>
                import(/* webpackChunkName: "components" */ "./components/MyBoat.vue"),
            SystemStatus: () =>
                import(/* webpackChunkName: "components" */ "./components/SystemStatus.vue"),
            Control: () =>
                import(/* webpackChunkName: "components" */ "./components/Control.vue"),
            Sensors: () =>
                import(/* webpackChunkName: "components" */ "./components/SensorList.vue")
        },
        setup() {
            onMounted(() => {
                //sensor.GetData();
            });
        }
    });
</script>
<style scoped>
    .settings-page > .col {
        padding: 2px 0;
    }

    .settings-page > .col:first-child {
        padding-top: 2px;
    }

    .settings-page ::v-deep .headerRow {
        min-height: 28px;
        padding-right: 8px;
        padding-left: 8px;
    }

    .settings-page ::v-deep .headerRow .font-weight-bold {
        font-size: var(--app-font-body);
    }

    #settings ::v-deep .v-item-group .v-expansion-panel .v-expansion-panel-header {
        min-height: 42px;
        padding-top: 2px;
        padding-bottom: 2px;
        font-size: var(--app-font-body);
    }

    #settings ::v-deep .v-item-group .v-expansion-panel .v-expansion-panel-content__wrap {
        padding-top: 8px;
        padding-bottom: 8px;
    }

    #settings ::v-deep #myBoat .enableDisableItem {
        min-height: 42px;
        align-items: center;
    }

    #settings ::v-deep #myBoat .v-list-item__icon {
        width: 40px;
        min-width: 40px;
        height: 40px;
        align-self: center;
        margin-left: 8px;
        margin-right: 8px;
    }

    #settings ::v-deep #myBoat .v-list-item__content {
        height: 40px;
        padding: 0 8px 0 0;
    }

    #settings ::v-deep #myBoat .v-list-item__title {
        height: auto;
        padding-left: 0;
        font-size: var(--app-font-body);
        line-height: 1.2;
    }

    .settings-page ::v-deep .v-btn:not(.v-btn--icon) {
        min-height: 36px;
        font-size: var(--app-font-body);
    }

    #settings ::v-deep .sensor-icon,
    #settings ::v-deep .v-list-item__icon .v-image {
        width: 40px !important;
        height: 40px !important;
        max-width: 40px !important;
        max-height: 40px !important;
    }

    #settings ::v-deep .header-actions .arrow {
        width: 18px;
        font-size: 24px !important;
    }

    #settings ::v-deep .panel-image,
    #settings ::v-deep .panel-action {
        height: 80px;
    }

    #settings ::v-deep .panel-action--top {
        min-height: 56px;
    }

    #settings ::v-deep .panel-label {
        min-height: 24px;
        font-size: var(--app-font-tiny);
        line-height: 12px;
    }

    #settings ::v-deep .panel-icon .v-image {
        max-width: 32px !important;
        max-height: 32px !important;
    }

    #settings ::v-deep .panel-icon .v-icon,
    #settings ::v-deep .v-expansion-panel-content__wrap .v-icon {
        font-size: 22px !important;
    }

    #settings ::v-deep .panel-image .v-image {
        max-width: 80px !important;
        max-height: 80px !important;
    }

    #settings ::v-deep .action-icon .v-image {
        width: 32px !important;
        height: 32px !important;
        max-width: 32px !important;
        max-height: 32px !important;
    }

    #settings ::v-deep .gateway-action-icon .v-image {
        width: 40px !important;
        height: 40px !important;
        max-width: 40px !important;
        max-height: 40px !important;
    }

    #settings ::v-deep .gateway-image {
        width: 44%;
        max-width: 210px;
        max-height: 140px;
        object-fit: contain;
    }

    #settings ::v-deep .gateway-image-row {
        margin-top: 4px !important;
        margin-bottom: 4px !important;
    }

    #settings ::v-deep .gateway-functions-heading,
    #settings ::v-deep .gateway-actions-row {
        margin-bottom: 4px !important;
    }

    #settings ::v-deep .gateway-action {
        padding-right: 8px !important;
        padding-left: 8px !important;
    }

    #settings ::v-deep .gateway-actions-row .action-icon {
        width: 44px !important;
        height: 44px !important;
    }

    #settings ::v-deep .gateway-content-card {
        padding: 5px !important;
    }

    #settings ::v-deep .gateway-content-card .v-row.mb-2 {
        margin-bottom: 4px !important;
    }

    #settings ::v-deep .gateway-content-card .v-progress-linear {
        height: 14px !important;
    }

    #settings ::v-deep .gateway-content-card .caption {
        font-size: var(--app-font-caption) !important;
    }

    #settings ::v-deep .gateway-actions-row .action-icon .v-image {
        width: 28px !important;
        height: 28px !important;
        max-width: 28px !important;
        max-height: 28px !important;
    }

    #settings ::v-deep .captains-logbook-panel .v-expansion-panel-content__wrap {
        padding-top: 4px;
        padding-bottom: 4px;
    }

    #settings ::v-deep .captains-logbook-panel .col {
        padding-top: 4px;
        padding-bottom: 4px;
    }

    #settings ::v-deep .captains-logbook-panel .row + .row {
        margin-top: 4px !important;
    }

    #settings ::v-deep .captains-logbook-panel .v-col {
        padding-top: 6px;
        padding-bottom: 6px;
    }

    #settings ::v-deep .captains-logbook-panel .v-btn:not(.v-btn--icon) {
        min-height: 40px;
        font-size: var(--app-font-compact);
    }

    #settings ::v-deep .captains-logbook-panel .v-icon {
        font-size: 20px !important;
    }

    #settings ::v-deep .captains-logbook-panel .v-text-field {
        font-size: var(--app-font-body);
    }

    #settings ::v-deep .captains-logbook-panel .v-list-item {
        min-height: 42px;
    }

    #settings ::v-deep .captains-logbook-panel .v-list-item__content {
        padding-top: 4px;
        padding-bottom: 4px;
    }

</style>
